<template lang="pug">
  app-modal.modalNotificar(
    :titulo="titulo()"
    :width="width"
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      app-modal-selecionar-modelo-notificacao(
        :tiposModelo="tiposModelo",
        titulo='Modelos de Notificação',
        :idProcesso="this.idProcesso"
        v-if="showModalNotificacao",
        :showModal="showModalNotificacao"
        @closeModal="fecharModalNotificacao",
        @setTextoNotificacao="setTextoNotificacao"
      )
      p
      div.mb(v-if="conversas.length > 0 && conversas.tipo === 'SINALIZACAO_PENDENCIA'" v-for="item in conversas", :key="item.id")
        p
          b Sinalização: &nbsp{{ item.assunto }}
        el-collapse()
          el-collapse-item(
            v-for="msg in item.mensagemList",
            :key="msg.id",
            :name='msg.id',
          )
            template(slot="title")
              div.flex.title.full-width
                span {{ msg.nomeRemetente}}
                span {{ msg.dataEnviada }} &nbsp
            el-row.margin-top
              p(v-html="msg.conteudo")
      div.display-flex
        div.label-width
          app-label(
            label="Mensagem:",
            :required="true"
          )
        div
          el-button.btn(
            type="primary",
            @click="openModalNotificacao()",
          )
            span.center
              i.fa.fa-file.icon
              b &nbsp Modelo
      validation-provider(rules="required", v-slot="{ errors }")
        app-editor-texto.input(
          :value="mensagem",
          @onTextChange="onTextChange"
          :class="{'erro' : errors.length}"
          ref="editorTexto"
        )
        span.help.erro {{ errors[0] }}

      h4 Anexos mensagem
      app-anexo(
        :id="'upload-notificacao'"
        @removeFile="removeFile",
        @uploadFile="uploadFile",
        :exibirDownload="false",
        :files="anexos",
        scope="anexos",
        v-model="anexos",
      )
    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="$emit('closeModal')"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(
          type="success",
          size="small",
          @click="checkValidacao()"
          v-if="isNovaConversa"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
</template>

<script>
import { mapActions } from 'vuex'
import AppDisplay from '@/components/AppDisplay'
import AppLabel from '@/components/AppLabel'
import AppModal from '@/components/AppModal'
import AppAnexo from '@/components/AppAnexo'
import moment from 'moment'
import AppEditorTexto from '@/components/AppEditorTexto'
import FileHelper from '@/utils/fileHelper'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalSelecionarModeloNotificacao from '../../components/AppModalSelecionarModeloNotificacao'

export default {

  components: {
    AppDisplay,
    AppLabel,
    AppModal,
    AppAnexo,
    AppEditorTexto,
    AppModalSelecionarModeloNotificacao,
    FileHelper
  },

  mixins: [
    AppNotificacao
  ],
  props: {
    width: {
      type: Number,
      default: 850
    },
    isVisualizacao: {
      type: Boolean,
      default: false
    },
    idProcesso: {
      required: false
    },
    idDespacho: {
      required: true
    },
    setor: {
      type: String
    }
  },

  data () {
    return {
      anexos: [],
      mensagem: '',
      conversas: [],
      isNovaConversa: true,
      showModalNotificacao: false,
      tiposModelo: [2], // Notificação
      isEstadoMa: process.env.ESTADO === 'ma'
    }
  },
  async created () {
    const { id } = await this.getUsuario()
    await this.getPrazoNotificacao()
    const { content } = await this.conversaByProcessoId({ idProcesso: this.idProcesso, idUsuario: id, tamanhoPagina: 100 })
    this.conversas = content

    if (this.conversas && this.conversas.length > 0) {
      this.isNovaConversa = this.conversas[this.conversas?.length - 1].status === 'ENCERRADA'
      this.$emit('updateHasConversa', this.isNovaConversa)
    }
  },

  methods: {
    ...mapActions({
      criarMensagem: 'conversa/criarMensagem',
      addMensagem: 'conversa/addMensagem',
      encerrarConversa: 'conversa/encerrarConversa',
      conversaByProcessoId: 'conversa/conversaByProcessoId',
      getUsuario: 'auth/getUsuario',
      downloadDocumentos: 'download/download',
      getPrazoNotificacaoByTipo: 'prazoNotificacao/getPrazoNotificacaoByTipo'
    }),

    async getPrazoNotificacao () {
      const today = new Date()
      const prazoNotificacao = await this.getPrazoNotificacaoByTipo('TODOS')
      // Pega a data atual e soma com o prazo de Notificação
      this.prazo = today.setDate(today.getDate() + prazoNotificacao)
    },

    titulo () {
      return 'Sinalizar Pendência'
    },

    formataDataHora (data) {
      return moment(data).format('DD/MM/YYYY HH:mm')
    },

    async uploadFile (file) {
      this.anexos.push({ key: file.response, nome: file.name })
    },

    removeFile (file) {
      const teste = this.anexos.findIndex(obj => obj === file)
      this.anexos.splice(teste, 1)
    },
    onTextChange (value) {
      this.mensagem = value
    },

    async checkValidacao () {
      const valido = this.mensagem
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      } else {
        this.confirmBox(this.$messages.INICIA_SINALIZAO_PENDENCIA, this.$messages.TITULO_WARNING, () => {
          this.sendMessage()
        })
        return false
      }
    },

    async sendMessage () {
      let mensagem = {
        mensagemList: [
          {
            anexoList: this.anexos,
            conteudo: this.mensagem
          }
        ],
        processo: {
          id: this.idProcesso
        }
      }
      if (this.isNovaConversa) {
        mensagem.tipo = 'SINALIZACAO_PENDENCIA'
        mensagem.despacho = (this.idDespacho === null || this.idDespacho === undefined) ? null : {id: this.idDespacho}
        mensagem.tipoNotificacao = 'SINALIZACAO_PENDENCIA'
        this.criarMensagem(mensagem).then(() => {
          this.feedBack('Pendência incluída no processo')
          this.isGoBack()
        })
      }
      if (!this.isNovaConversa) {
        this.conversas.map((conversa) => {
          if (conversa.status === 'ABERTA') {
            mensagem.id = conversa.id
            this.addMensagem(mensagem).then(() => {
              this.feedBack('Pendência incluída no processo')
              this.isGoBack()
            })
          }
        })
      }
    },

    feedBack (msg) {
      this.showNotificacao(
        this.$messages.TIPO_SUCCESS,
        this.$messages.TITULO_SUCCESS,
        msg
      )
      this.$emit('closeModal')
    },

    setTextoNotificacao (textoNotificacao) {
      this.$refs.editorTexto.text = textoNotificacao
      this.$refs.editorTexto.emitTextChange()
    },

    openModalNotificacao () {
      this.showModalNotificacao = true
    },

    fecharModalNotificacao () {
      this.showModalNotificacao = false
    },

    async download (anexo) {
      const arquivo = await this.downloadDocumentos(anexo)

      FileHelper.saveFile(arquivo, anexo.nome)
    },
    isGoBack () {
      if (this.isEstadoMa) {
        this.$router.back()
      }
    }
  }
}

</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.title {
  font-weight: 400;
  color: #909399 !important;
  font-size: 16px !important;
}

.width80 {
  width: 80%;
}

.mb {
  margin-top: 10px;
  margin-bottom: 18px;
}
.width90 {
  width: 97%;
}
.full-width {
  width: -webkit-fill-available;
}

.bold {
  font-weight: bold;
}

.cancelar-solicitacao i {
  margin-right: 30px;
  cursor: pointer;
  color: #339d67 !important;
}

.cancelar-solicitacao i:hover {
  color: #3bb281 !important;
}

.display-flex {
  width: 100%;
  display: flex;
}

.center {
  display: flex;
  align-items: center;
}

.label-width {
  width: 90%;
}

.btn {
  padding: 7px;
}

@media (max-width: 780px) {
  .modalNotificar {
    position: fixed !important;
    width: 395px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalSinalizarPendencia.vue